const tables = [
  {
    name: "Number",
  },
  {
    name: "Purchase|Recived",
  },
  {
    name: "Supplier",
  },
  {
    name: "Product",
  },
  {
    name: "Sale",
  },
  {
    name: "Tax",
  },
  {
    name: "Stock",
  },
  {
    name: "Expiry",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
